import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ARROW_SIZE,
  arrowsRowClasses,
  leftEdgeGradientClasses,
  rightEdgeGradientClasses,
  slideContainerClasses,
  slideItemClasses,
  viewportClasses,
} from './styles';
import { type CarouselProps } from './types';
import { useCarousel } from './useCarousel';

export const Carousel = ({ items, header, loop = false }: CarouselProps): ReactElement => {
  const { emblaRef, canScrollPrev, canScrollNext, scrollPrev, scrollNext } = useCarousel({ loop });
  const { t } = useTranslation(LOCIZE_NS.HOME);

  return (
    <div className="flex w-full flex-col gap-4">
      {header && <div className="order-1 min-w-0 am-xl:hidden">{header}</div>}
      <div className="relative order-2 min-w-0 overflow-x-visible am-xl:order-2">
        <div className={viewportClasses} ref={emblaRef}>
          <div className={slideContainerClasses}>
            {items.map((item, index) => (
              <div key={index} className={slideItemClasses}>
                {item}
              </div>
            ))}
          </div>
        </div>
        {canScrollNext && <div className={rightEdgeGradientClasses} />}
        {canScrollPrev && <div className={leftEdgeGradientClasses} />}
      </div>
      <div className={cn(arrowsRowClasses, 'order-3 am-xl:order-1')}>
        {header && <div className="mr-auto hidden min-w-0 am-xl:block">{header}</div>}
        <Button
          onClick={scrollPrev}
          variant="secondary"
          size="md"
          icon="only"
          aria-label={t('Home.Carousel.previous')}
          disabled={!canScrollPrev}
        >
          <ChevronLeft className={ARROW_SIZE} />
        </Button>
        <Button
          onClick={scrollNext}
          variant="secondary"
          size="md"
          icon="only"
          aria-label={t('Home.Carousel.previous')}
          disabled={!canScrollNext}
        >
          <ChevronRight className={ARROW_SIZE} />
        </Button>
      </div>
    </div>
  );
};
